import { useDocumentClassName } from "../../hooks/useDocumentClassName";

export const Document = ({ className, children }) => {
  useDocumentClassName(className);

  return children;
};
